module.exports = __webpack_public_path__ + "img/dsci0100.3ac7d681.jpg";